if (!customElements.get('browprint-face-shapes')) {
  customElements.define(
    'browprint-face-shapes',
    class extends HTMLElement {
      connectedCallback() {
        const tiles = [...this.querySelectorAll('[data-bpfs-open]')];
        const dialog = this.querySelector('[data-bpfs-dialog]');
        const image = this.querySelector('[data-bpfs-full-image]');
        const close = this.querySelector('[data-bpfs-close]');
        const previous = this.querySelector('[data-bpfs-prev]');
        const next = this.querySelector('[data-bpfs-next]');
        if (!tiles.length || !dialog || !image) return;

        let activeIndex = 0;
        const show = (index) => {
          activeIndex = (index + tiles.length) % tiles.length;
          const tile = tiles[activeIndex];
          image.src = tile.dataset.fullSrc;
          image.alt = `${tile.dataset.faceName} face-shape BrowPrint recommendation`;
        };

        tiles.forEach((tile, index) => {
          tile.addEventListener('click', () => {
            show(index);
            dialog.showModal();
          });
        });

        close?.addEventListener('click', () => dialog.close());
        previous?.addEventListener('click', () => show(activeIndex - 1));
        next?.addEventListener('click', () => show(activeIndex + 1));
        dialog.addEventListener('click', (event) => {
          if (event.target === dialog) dialog.close();
        });
      }
    }
  );
}
